import { styled } from '@linaria/react';

import { MqDesktop, MqTablet, MqWide } from '~theme/media';

export const LayoutWrapper = styled.div`
	position: relative;
	display: grid;
	overflow: hidden;
	min-height: 0;
	flex-grow: 1;
	justify-content: space-between;
	padding-right: var(--base-gap);
	padding-left: var(--base-gap);
	gap: 0;
	grid-template-columns: 1fr 0;

	${MqTablet} {
		padding-right: var(--screen-padding);
		padding-left: var(--screen-padding);
		gap: 16px;
		grid-template-areas: 'left center';
		grid-template-columns: 245px 1fr;
	}

	${MqDesktop} {
		grid-template-columns: 280px 1fr;
	}

	${MqWide} {
		grid-template-areas: 'left center right';
		grid-template-columns: 280px 1fr 320px;
	}
`;
